import React, { useState, useEffect, } from "react";
import { useDispatch } from "react-redux";
import { useToast } from "@chakra-ui/react";
// Components
import DropZone from "./dropzone/dropzone";
import FilesList from "./filesList/filesList";
// Components
import Loading from '../common/loading/loading';
// Styles
import "./upload.css";
// Actions
import * as filesActions from "../../redux/actions/files";
// Utils
import { getToastOpt } from "../../utils/utils";

let enableOnChange = false;

const Upload = ({
  type,
  id,
  id2,
  style,
  onChange,
  onNewFile,
  onDeleteFile,
  onUpdateFile,
  showTextFile = false,
}) => {
  const dispatch = useDispatch();
  const toast = useToast();
  // States
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = useState([]);

  useEffect(() => {
    enableOnChange = false;
  }, []);

  useEffect(() => {
    if (id === null || id === undefined) return;

    // Get files
    setIsLoading(true);
    dispatch(filesActions.getFiles(type, id, id2)).then(
      (response) => {
        setIsLoading(false);
        setFiles(response);
      },
      (err) => {
        setIsLoading(false);
        toast(getToastOpt({
          title: `Error obtenint fitxers`,
          description: err,
          status: "error",
        }));
      }
    );
  }, [id]);

  useEffect(() => {
    if (!enableOnChange) {
      enableOnChange = true;
      return;
    }
    onChange(files);
  }, [files]);  

  const enabled =  (process.env.REACT_APP_UPLOAD_FILES_ENABLED || 'false').toLowerCase() == 'true';
  if (!enabled) return null;

  return (
    <div className="upload-wrapper" style={style}>
      <DropZone files={files} setFiles={setFiles} onNewFile={onNewFile} />
      <FilesList files={files} setFiles={setFiles} onDeleteFile={onDeleteFile} onUpdateFile={onUpdateFile} showTextFile={showTextFile} />
      {isLoading && <Loading />}
    </div>    
  );
};

export default Upload;
